var isMobile = function () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
  }
  export default isMobile
  


//////////////////
// WEBPACK FOOTER
// ./static/isMobile.js
// module id = 5iYh
// module chunks = 1